module.exports = __webpack_public_path__ + "media/images/lb/637-e37231aae0c7042fa1f464dca3f468e9.svg";